import { CardContact } from "../../module/contact/card";

export default function ContactPage() {
    return <div className="col" style={{ gap: '8rem', padding: "min(5.2vw, 10rem) min(8vw, 15.2rem)" }}>
        <CardContact />
    </div>
}